import React, { useReducer, useContext, useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MenuList } from "./Menu";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { useSelector, useDispatch } from 'react-redux';
import { loadMenu } from '../../../store/menu/menuActions';
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
const reducer = (previousState, updatedState) => ({
	...previousState,
	...updatedState,
});
const initialState = {
	active: "",
	activeSubmenu: "",
};
const SideBar = () => {
	let d = new Date();
	const { t, i18n } = useTranslation();
	const {
		iconHover,
		sidebarposition,
		headerposition,
		sidebarLayout,
		ChangeIconSidebar,
	} = useContext(ThemeContext);

	const [state, setState] = useReducer(reducer, initialState);
	const dispatch = useDispatch();
	const menu = useSelector(state => state.menu || { loading: false, data: [] });
	console.log('menumenu', menu)
	const authUser = useSelector(state => state.auth?.auth?.user);

	const resolveDynamicRoute = (to) => {
		if (!to || typeof to !== "string") return to;
		try {
			const userContextRaw = localStorage.getItem("userContext");
			if (!userContextRaw) return to;
			const ctx = JSON.parse(userContextRaw);
			let resolved = to;
			resolved = resolved.replace(/{companyId}/g, ctx.companyId || "");
			resolved = resolved.replace(/{branchId}/g, ctx.branchId || "");
			resolved = resolved.replace(/{assignmentId}/g, ctx.assignmentId || "");
			return resolved;
		} catch (err) {
			return to;
		}
	};

	// Get bilingual text with inline format for menu items
	const getBilingualMenuText = (title) => {
		if (!title) return title;
		// Convert "Add User" to "addUser", "Manage User" to "manageUser", etc.
		const key = title
			.split(" ")
			.map((word, idx) => idx === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1))
			.join("");
		const englishText = t(`nav.${key}`, { lng: 'en' }) || title;
		const tamilText = t(`nav.${key}`, { lng: 'ta' });
		const currentLang = i18n.language || 'en';
		
		// If Tamil language is selected and Tamil text exists and is different from English
		if (currentLang === 'ta' && tamilText && englishText !== tamilText) {
			return (
				<span style={{ display: 'inline-block' }}>
					{englishText}
					<div style={{ fontSize: '11px'}}>
						({tamilText})
					</div>
				</span>
			);
		}
		return englishText;
	};

	// Get full path for URL matching
	const currentPath = window.location.pathname;

	// Check if a URL matches the current path
	const isPathActive = (itemPath) => {
		if (!itemPath) return false;
		const resolvedPath = resolveDynamicRoute(itemPath);
		// Match both exact path and parent paths
		return currentPath === resolvedPath || currentPath.startsWith(resolvedPath + "/");
	};

	// Check if any child menu item is active
	const isParentActive = (menuItem) => {
		if (!menuItem.content) return false;
		return menuItem.content.some(child => {
			if (isPathActive(child.to)) return true;
			if (child.content) {
				return child.content.some(grandchild => isPathActive(grandchild.to));
			}
			return false;
		});
	};

	useEffect(() => {
		// Auto-open parent menu if any child is active
		if (menu && menu.data && menu.data.length > 0) {
			menu.data.forEach((item) => {
				if (isParentActive(item) && state.active !== item.title) {
					setState({ active: item.title });
				}
			});
		}
	}, [currentPath, menu]);

	useEffect(() => {
		// Only load menu after auth user is available
		const fetchMenuByRole = () => {
			try {
				const userContext = localStorage.getItem("userContext");
				let roleCode = authUser?.activeRole?.roleCode;
				if (userContext) {
					const context = JSON.parse(userContext);
					roleCode = context.roleCode || "";
				}
				dispatch(loadMenu(roleCode));
			} catch (error) {
				console.error('Failed to dispatch menu load', error);
				toast("Using default menu. Some items may not be visible.", {
					icon: "ℹ️",
					duration: 4000,
				});
			}
		};
		if (authUser) {
			fetchMenuByRole();
		}
		const handleStorageChange = (e) => {
			if (e.key === "userContext" && e.newValue && authUser) {
				fetchMenuByRole();
			}
		};
		window.addEventListener("storage", handleStorageChange);
		return () => {
			window.removeEventListener("storage", handleStorageChange);
		};
	}, [authUser]);

	const [hideOnScroll, setHideOnScroll] = useState(true);
	useScrollPosition(
		({ prevPos, currPos }) => {
			const isShow = currPos.y > prevPos.y;
			if (isShow !== hideOnScroll) setHideOnScroll(isShow);
		},
		[hideOnScroll]
	);

	const handleMenuActive = (status) => {
		setState({ active: status });
		if (state.active === status) {
			setState({ active: "" });
		}
	};
	const handleSubmenuActive = (status) => {
		setState({ activeSubmenu: status });
		if (state.activeSubmenu === status) {
			setState({ activeSubmenu: "" });
		}
	};
	
	let path = window.location.pathname;
	path = path.split("/");
	path = path[path.length - 1];

	// Exclude these quick-links from the full sidebar to avoid duplication
	const excludedTitles = ["Dashboard", "Users", "Customers", "Branches"];
	const renderedMenu = (menu && menu.data && menu.data.length > 0)
		? menu.data.filter(item => !excludedTitles.includes(item.title))
		: [].filter(item => !excludedTitles.includes(item.title));

	return (
		<div
			onMouseEnter={() => ChangeIconSidebar(true)}
			onMouseLeave={() => ChangeIconSidebar(false)}
			className={`dlabnav ${iconHover} ${
				sidebarposition.value === "fixed" &&
				sidebarLayout.value === "horizontal" &&
				headerposition.value === "static"
					? hideOnScroll > 120
						? "fixed"
						: ""
					: ""
			}`}
		>
			<PerfectScrollbar className="dlabnav-scroll">
				<ul className="metismenu" id="menu">
					{(!authUser || menu.loading) ? (
						<li className="text-center py-4">
							<div
								className="spinner-border spinner-border-sm text-primary"
								role="status"
							>
								<span className="sr-only">Loading menu...</span>
							</div>
							<p className="text-muted mt-2 mb-0" style={{ fontSize: "12px" }}>
								Loading menu...
							</p>
						</li>
						) : (
						renderedMenu.map((data, index) => {
							let menuClass = data.classsChange;
							if (menuClass === "menu-title") {
								return (
									<li className={menuClass} key={index}>
										{getBilingualMenuText(data.title)}
									</li>
								);
							} else {
								return (
									<li
										className={` ${
											state.active === data.title || isParentActive(data)
												? "mm-active"
												: ""
										}`}
										key={index}
									>
										{data.content && data.content.length > 0 ? (
											<>
												<Link
													to={"#"}
													className="has-arrow"
													onClick={() => {
														handleMenuActive(data.title);
													}}
												>
													{data.icon ? (
														<i
															className={`material-icons${
																data.iconType === "outlined" ? "-outlined" : ""
															}`}
														>
															{data.icon}
														</i>
													) : (
														data.iconStyle
													)}
													<span className="nav-text">{getBilingualMenuText(data.title)}</span>
													<span className="ms-1 badge badge-xs style-1 badge-danger">
														{data.update}
													</span>
												</Link>
												<Collapse
													in={state.active === data.title || isParentActive(data) ? true : false}
												>
													<ul
														className={`${
															menuClass === "mm-collapse" ? "mm-show" : ""
														}`}
													>
														{data.content &&
															data.content.map((data, index) => {
																return (
																	<li
																		key={index}
																		className={`${
																			state.activeSubmenu === data.title
																				? "mm-active"
																				: ""
																		}`}
																	>
																		{data.content && data.content.length > 0 ? (
																			<>
																				<Link
																					to={resolveDynamicRoute(data.to)}
																					className={
																						data.hasMenu ? "has-arrow" : ""
																					}
																					onClick={() => {
																						handleSubmenuActive(data.title);
																					}}
																				>
																					{getBilingualMenuText(data.title)}
																				</Link>
																				<Collapse
																					in={
																						state.activeSubmenu === data.title
																							? true
																							: false
																					}
																				>
																					<ul
																						className={`${
																							menuClass === "mm-collapse"
																								? "mm-show"
																								: ""
																						}`}
																					>
																						{data.content &&
																							data.content.map(
																								(data, index) => {
																									return (
																										<li key={index}>
																											<Link
																												className={`${
																													isPathActive(data.to)
																														? "mm-active"
																														: ""
																												}`}
																												to={resolveDynamicRoute(
																													data.to
																												)}
																											>
																												{getBilingualMenuText(data.title)}
																											</Link>
																										</li>
																									);
																								}
																							)}
																					</ul>
																				</Collapse>
																			</>
																		) : (
																			<Link to={resolveDynamicRoute(data.to)}>
																				{getBilingualMenuText(data.title)}
																			</Link>
																		)}
																	</li>
																);
															})}
													</ul>
												</Collapse>
											</>
										) : (
											<Link 
												to={resolveDynamicRoute(data.to)}
												className={`${isPathActive(data.to) ? "mm-active" : ""}`}
											>
												{data.icon ? (
													<i
														className={`material-icons${
															data.iconType === "outlined" ? "-outlined" : ""
														}`}
													>
														{data.icon}
													</i>
												) : (
													data.iconStyle
												)}
												<span className="nav-text">{getBilingualMenuText(data.title)}</span>
											</Link>
										)}
									</li>
								);
							}
						})
					)}
				</ul>
			</PerfectScrollbar>
		</div>
	);
};

export default SideBar;